import { Container, Typography } from '@mui/material';

import { ButtonLink } from '@components/navigation';
import { HOME } from '@navigation/routes.paths';

import type { PageComponent } from '../../pages.types';

export const Error404Page: PageComponent = () => {
  return (
    <Container data-testid='404_page'>
      <Typography variant='display1'>404</Typography>
      <Typography variant='h1'>Страница не найдена.</Typography>
      <Typography variant='h2'>
        Страница, которую вы ищете, возможно, была удалена.
      </Typography>
      <ButtonLink to={HOME}>Вернуться на главную страницу</ButtonLink>
    </Container>
  );
};

export default Error404Page;
